import { useEffect, useState, useSyncExternalStore } from 'react';
import { Icon } from '../components/Icon.jsx';

/**
 * Exxas sperrt bei zu vielen Anfragen bis zu 60 s (für alle Benutzer). Statt dass die App «hängt», zeigt sie
 * dann oben einen Hinweis mit Countdown; Abfragen laufen danach automatisch weiter (Retry in main.jsx).
 */
let pauseBis = 0;
const hoerer = new Set();

/** Von api.js bei 429 aufgerufen. */
export function meldeExxasPause(sekunden) {
  const bis = Date.now() + Math.min(Math.max(Number(sekunden) || 30, 1), 120) * 1000;
  if (bis <= pauseBis) return;
  pauseBis = bis;
  hoerer.forEach((h) => h());
}

const usePauseBis = () => useSyncExternalStore((h) => { hoerer.add(h); return () => hoerer.delete(h); }, () => pauseBis);

export function ExxasPause() {
  const bis = usePauseBis();
  const [jetzt, setJetzt] = useState(Date.now());
  const rest = Math.ceil((bis - jetzt) / 1000);
  useEffect(() => {
    if (bis <= Date.now()) return undefined;
    setJetzt(Date.now());
    const iv = setInterval(() => setJetzt(Date.now()), 1000);
    return () => clearInterval(iv);
  }, [bis]);
  if (rest <= 0) return null;
  return (
    <div className="notice info" role="status" aria-live="polite"
      style={{ position: 'fixed', top: 'calc(env(safe-area-inset-top, 0px) + 8px)', left: 12, right: 12, zIndex: 60, maxWidth: 560, margin: '0 auto', boxShadow: '0 6px 24px rgba(0,0,0,.18)' }}>
      <Icon name="clock" size={18} />
      <span>Exxas pausiert kurz (zu viele Anfragen). Die App macht in {rest} s automatisch weiter – nichts geht verloren.</span>
    </div>
  );
}
